import React from "react";

import { Props } from "./types";
import styles from "./styles.scss";

function TextFields({ textFields }: Props) {
  return (
    <div className={styles.textFields}>
      {[...textFields]
        .sort((a, b) => (a.order < b.order ? -1 : 1))
        .map((field, index) => (
          <div className={styles.section}>
            <p className={styles.name}>{field.name}</p>
            <p className={styles.content}>{field.value}</p>
          </div>
        ))}
    </div>
  );
}

export { TextFields };
